import { RcFile } from 'antd/lib/upload';

import { MediaTypeId } from 'pricing/types';
import { apiMedia } from 'utilities/http/api/pricing/apiMedia';

export const contractUploadMediaAmendment = async (contractId: number, media: RcFile) => {
  const mediaUpload = {
    mediaTypeId: MediaTypeId.BreederContractAmendment,
    mediaEntityId: contractId,
    mediaEntity: 'breederContract',
    viewOrder: 1,
    isDefault: 1,
    file: media,
  };

  await apiMedia.uploadMedia(mediaUpload);
};
